<ion-menu-toggle>
  <ion-button class="menu-toggle-button">
    @if (availableUpdateVersion$ | async) {
      <ion-badge class="update-available"></ion-badge>
    }
    <ion-icon class="parentHubLogo" slot="icon-only" src="/assets/icon/parent-hub-logo.svg"></ion-icon>
  </ion-button>
</ion-menu-toggle>
